function getSize(size) {
  const SIZES = {
    '0': '0',
    px: '1px',
    '3xs': '4px',
    '2xs': '8px',
    xs: '12px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    xl: '40px',
    '2xl': '48px',
    '3xl': '64px',
    '4xl': '80px',
    '5xl': '96px',
    '6xl': '128px'
  };

  return SIZES[size];
}

export default function createStack(axis) {
  const dir = axis === 'x' ? 'left' : 'top';
  let size = null;
  let count = 0;
  return {
    bind: function(el, binding) {
      size = getSize(binding.arg);
      const children = Array.from(el.children);
      count = children.length;
      if (count === 0) return;
      children.forEach((child, i) => {
        if (i === 0) return;
        child.style.setProperty(`margin-${dir}`, size);
      });
    },
    componentUpdated: function(el, binding) {
      const newSize = getSize(binding.arg);
      const children = Array.from(el.children);
      const newCount = children.length;

      if (newCount === 0) return;
      if (size === newSize && count === newCount) return;

      children.forEach((child, i) => {
        if (i === 0) return;
        child.style.setProperty(`margin-${dir}`, newSize);
      });
      size = newSize;
      count = newCount;
    }
  };
}
